import { Injectable } from '@angular/core';
import { UserData } from '../models';

@Injectable({
    providedIn: 'root'
})
export class UserFrontendService {
    private static LOCAL_USER_STORAGE_NAME = 'UserData';

    private _localeChanged = false;
    private _defaultLocale = "fr-FR";
    private _defaultLang = "fr";

    private _userData: UserData|undefined|null = undefined;
    private _locale: string|undefined|null = undefined;
    private _lang: string|undefined|null = undefined;

    set userData(userData: UserData|null) {
        this._localeChanged = true;
        this._userData = userData;
        window.localStorage.setItem(UserFrontendService.LOCAL_USER_STORAGE_NAME, JSON.stringify(userData));
    }

    get userData(): UserData|null {
        this.loadUserData();
        return this._userData!;
    }

    get sub(): string | null {
        return this.loadUserData()?.sub ?? null;
    }

    get defaultLocale(): string {
        return this._defaultLocale;
    }

    set defaultLocale(locale: string) {
        this._defaultLocale = locale;
    }

    get defaultLang(): string {
        return this._defaultLang;
    }

    set defaultLang(lang: string) {
        this._defaultLang = lang;
    }

    get locale(): string {
        this.loadUserData()
        return this._locale ?? navigator.language ?? this.defaultLocale;
    }

    get lang(): string {
        this.loadUserData()
        return this._lang ?? navigator.language ?? this.defaultLang;
    }

    get localeChanged(): boolean {
        return this._localeChanged;
    }

    /**
     * Indiquer si le sub fourni est celui de l’utilisateur actuel.
     * @param Sub     Le sub à tester.
     * @returns       true si c’est l’utilisateur actuel, false sinon.
     */
    public isCurrentUserSub(Sub: string | null) {
        if (Sub === null) {
            return false;
        }
        return this.sub === Sub;
    }

    public clear() {
        window.localStorage.removeItem(UserFrontendService.LOCAL_USER_STORAGE_NAME);
    }

    private loadUserData() {
        if (this._userData === undefined) {
            this._userData = null;
            const str = window.localStorage.getItem(UserFrontendService.LOCAL_USER_STORAGE_NAME);
            if (str) {
                this._userData = JSON.parse(str);
            }
        }
        this._locale = this._userData?.locale;
        if (this._locale) {
            const parts = this._locale.split('-');
            this._lang = parts[0];
        }
        return this._userData;
    }

}
